import { StringifiableRecord, stringifyUrl } from 'query-string';

export const getIsNew = (id?: string) => id === 'new';

export const addQueryParamsToURL = (url: string, queryParams?: StringifiableRecord) => stringifyUrl({
  url,
  query: queryParams,
}, {
  skipNull: true,
  skipEmptyString: true,
  arrayFormat: 'comma',
});

export const getConfidenceColor = <T>(ocrScores: T) => (name: string) => {
  const score = (ocrScores[`${name}Score` as keyof T]);
  const ocrScore = ocrScores[`${name}OcrScore` as keyof T];

  const scoresSumm = (Number(score) + Number(ocrScore)) / 2;

  if (scoresSumm > 0.80 && scoresSumm <= 0.90) {
    return '#F3CCCB';
  }

  if (scoresSumm >= 0.70 && scoresSumm < 0.80) {
    return '#E99798';
  }

  if (scoresSumm < 0.70 && scoresSumm > 0.05) {
    return '#D56465';
  }

  return undefined;
};

const getTranslation = (
  locale: string,
) => <T extends Record<string, unknown>, >(
  translations?: T[],
) => translations?.find((tr) => tr.locale === locale) as T;

export const getEnTranslation = getTranslation('en-CA');
export const getFrTranslation = getTranslation('fr-CA');
